import { matchRoutes, useLocation } from 'react-router-dom';

const ROUTES = [
  { path: '/', name: 'channel' },

  {
    path: '/manager',
    name: 'stream_manager'
  },
  {
    path: '/health',
    name: 'stream_health'
  },
  { path: 'login', name: 'login' }
];

const useCurrentPage = () => {
  const location = useLocation();
  const [match] = matchRoutes(ROUTES, location) || [];
  return match?.route?.name;
};

export default useCurrentPage;
